module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki01_pc-3136fb01c38bf4ddca5981981e50085e.jpg";